<template>
    <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive transaction-table p-0">
            <table class="table main-table ">
                <thead>
                    <tr>
                        <th> Date</th>
                        <th> Category </th>
                        <th> Dealer </th>
                        <th> Retailer </th>
                        <th> Retailer User</th>
                        <th> Transaction Type </th>
                        <th> Details </th>
                        <th> Total Amount</th>
                        <th> SRP </th>
                        <th> Amount Deducted</th>
                        <th> Reference Number</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="filter-background">
                        <td>
                            <Datepicker v-model="filters.dateRange" :enable-time-picker="false"
                                class="form-control p-0 m-0 border" multi-calendars range />
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.categoryWithItems" type="text" class="form-control"
                                    placeholder="Filter Category" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.dealer" type="text" class="form-control"
                                    placeholder="Filter Dealer" />
                            </div>
                        </td>

                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.retailer" type="text" class="form-control"
                                    placeholder="Filter Retailer" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.retailerUser" type="text" class="form-control"
                                    placeholder="Filter Retailer User" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.type" type="text" class="form-control"
                                    placeholder="Filter Type" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.details" type="text" class="form-control"
                                    placeholder="Filter Details" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.totalAmount" type="number" class="form-control"
                                    placeholder="Filter Amount" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.amount" type="number" class="form-control"
                                    placeholder="Filter SRP" />
                            </div>
                        </td>

                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.amountDeducted" type="number" class="form-control"
                                    placeholder="Filter Amount Deducted" />
                            </div>
                        </td>

                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.referenceNumber" type="text" class="form-control"
                                    placeholder="Filter Reference" />
                            </div>
                        </td>
                    </tr>
                    <tr v-if="loading">
                        <td colspan="10">
                            <div class="text-center">
                                <Vue3Lottie :animationData="searchingJSON" class="height-150 py-2" />
                            </div>
                        </td>
                    </tr>
                    <tr v-if="!loading && pageItems.length == 0">
                        <td colspan="10">
                            <div class="text-center">
                                <Vue3Lottie :animationData="noDataJSON" class="height-150 py-2" />
                                <p class="text-xs font-weight-bold">No Data Found</p>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="(transaction, index) in pageItems" :key="index"
                        :class="{ 'highlighted-row': selectedTransactionID === transaction.subRetailerUserLogID }">
                        <td>
                            {{ $format.FormatFullDateTime(transaction.date) }}
                        </td>
                        <td>
                            <div class="text-uppercase d-flex justify-content-start align-items-center">
                                <span>{{ transaction.categoryWithItems?.split(' ')[0] }}</span>
                                <div class="bundle-row d-flex justify-content-start align-items-center cursor-pointer"
                                    @click="showBundleSidebar(transaction)">
                                    <div class="fw-bold ms-2" style="font-size: 10px;">
                                        {{ transaction.categoryWithItems?.split(' ').slice(1).join(' ') }}
                                    </div>
                                    <i v-if="transaction.categoryWithItems?.includes('SMART') || parseInt(transaction.categoryWithItems?.split(' ')[1]) > 0"
                                        class="fa fa-arrow-right ms-2"></i>

                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex flex-column justify-content-center">
                                <p class="main-text"> {{ transaction.retailer.name }}</p>
                                <p class="sub-text"> {{ transaction.retailer.corporateID }}</p>
                            </div>
                        </td>

                        <td>
                            <div class="d-flex flex-column justify-content-center">
                                <p class="main-text"> {{ transaction.subRetailer.name }}</p>
                                <p class="sub-text"> {{ transaction.subRetailer.branch }}</p>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex flex-column justify-content-center">
                                <p class="main-text">{{ transaction.subRetailerUser.name }}</p>
                                <p class="sub-text"> {{ transaction.subRetailerUser.username }}</p>
                            </div>
                        </td>
                        <td>
                            {{ transaction.type }}
                        </td>
                        <td>
                            {{ transaction.details }}
                        </td>
                        <td>
                            <span class="badge badge-sm bg-gradient-info"
                                :class="isBundle(transaction) ? 'bg-gradient-bundle' : 'bg-gradient-info'">
                                Php {{ transaction.totalAmount.toFixed(2) }}
                            </span>
                        </td>
                        <td>
                            Php {{ transaction.amount.toFixed(2) }}
                        </td>
                        <td>
                            Php {{ transaction.amountDeducted.toFixed(2) }}
                        </td>
                        <td>
                            {{ transaction.referenceNumber }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="paginate-div d-flex align-items-end mt-3 me-3">
            <vue-awesome-paginate class="ms-auto custom-pagination" :max-pages-shown="5"
                :total-items="filteredTransactions.length" :items-per-page="itemPerPage" :on-click="onPageChanged"
                v-model="currentPage" />
        </div>
    </div>
    <bundleDetail @clear-selection="selectedTransactionID = null"/>
    <smartDetail @clear-selection="selectedTransactionID = null" />
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import noDataJSON from "./../../../assets/no-data.json";
import searchingJSON from "./../../../assets/searching.json";
import bundleDetail from "./sidebar/bundleDetail.vue";
import smartDetail from "./sidebar/smartDetail.vue";

export default {
    components: {
        bundleDetail,
        smartDetail,
    },
    data() {
        return {
            noDataJSON,
            searchingJSON,
            itemPerPage: 10,
            pageItems: [],
            filters: {
                dateRange: [],
                dealer: '',
                retailer: '',
                retailerUser: '',
                type: '',
                details: '',
                totalAmount: '',
                amount: '',
                amountDeducted: '',
                referenceNumber: '',
            },
            selectedTransactionID: null,
        };
    },
    computed: {
        ...mapState({
            currentPage: (state) => state.retailerController.transactionsCurrentPage,
            allTransactions: (state) => state.retailerController.allTransactions,
            loading: (state) => state.retailerController.allTransactionsLoading,
        }),
        filteredTransactions() {
            return this.allTransactions.filter((tx) => {
                const {
                    categoryWithItems,
                    dealer,
                    retailer,
                    retailerUser,
                    type,
                    details,
                    totalAmount,
                    amount,
                    amountDeducted,
                    referenceNumber,
                    dateRange,
                } = this.filters;

                const inRange =
                    Array.isArray(dateRange) &&
                        dateRange.length === 2 &&
                        dateRange[0] &&
                        dateRange[1]
                        ? new Date(tx.date) >= new Date(dateRange[0]) &&
                        new Date(tx.date) <= new Date(dateRange[1])
                        : true;

                return (
                    (!categoryWithItems || tx.categoryWithItems?.toLowerCase().includes(categoryWithItems.toLowerCase())) &&
                    (!dealer || tx.retailer?.name?.toLowerCase().includes(dealer.toLowerCase())) &&
                    (!retailer || tx.subRetailer?.name?.toLowerCase().includes(retailer.toLowerCase())) &&
                    (!retailerUser || tx.subRetailerUser?.name?.toLowerCase().includes(retailerUser.toLowerCase())) &&
                    (!type || tx.type?.toLowerCase().includes(type.toLowerCase())) &&
                    (!details || tx.details?.toLowerCase().includes(details.toLowerCase())) &&
                    (!totalAmount || tx.totalAmount?.toString().includes(totalAmount)) &&
                    (!amount || tx.amount?.toString().includes(amount)) &&
                    (!amountDeducted || tx.amountDeducted?.toString().includes(amountDeducted)) &&
                    (!referenceNumber || tx.referenceNumber?.toLowerCase().includes(referenceNumber.toLowerCase())) &&
                    inRange
                );
            });
        },
    },
    watch: {
        filters: {
            handler() {
                this.onPageChanged(1);
            },
            deep: true,
        },
        'filters.dateRange': {
            handler(newRange) {
                if (
                    Array.isArray(newRange) &&
                    newRange.length === 2 &&
                    newRange[0] &&
                    newRange[1]
                ) {
                    const start = new Date(newRange[0]);
                    const end = new Date(newRange[1]);

                    const changed = start.getHours() !== 0 || start.getMinutes() !== 0 || end.getHours() !== 23 || end.getMinutes() !== 59;

                    if (changed) {
                        start.setHours(0, 0, 0, 0);
                        end.setHours(23, 59, 59, 999);

                        this.filters.dateRange = [start, end];
                        return;
                    }

                    this.$store.commit('retailerController/SET_TransactionsFilter', {
                        ...this.$store.state.retailerController.transactionsFilter,
                        dateRange: [start, end],
                    });

                    const dateFrom = start.toISOString();
                    const dateTo = end.toISOString();

                    this.getAllTransactions({ dateFrom, dateTo }).then(() => {
                        this.onPageChanged(1);
                    });
                }
            },
            immediate: true,
        },
        allTransactions() {
            this.onPageChanged(1);
        }
    },
    methods: {
        ...mapActions({
            getAllTransactions: "retailerController/GetAllTransactions",
            getProductBundles: "productController/GetProductBundleByID",
            getProducts: "productController/GetSmartProductByID",
        }),
        ...mapMutations({
            setCurrentPage: "retailerController/SET_TransactionsCurrentPage",
            setShowBundleSidebar: "retailerController/SET_ShowBundleSidebar",
            setShowSmartSidebar: "retailerController/SET_ShowSmartSidebar",
            selectTransaction: "productController/SELECT_ProductBundle",
            selectProduct: "productController/SELECT_SmartProduct",
        }),

        onPageChanged(page) {
            this.setCurrentPage(page);
            this.pageItems = this.filteredTransactions.slice(
                (page - 1) * this.itemPerPage,
                page * this.itemPerPage
            );
        },
        async showBundleSidebar(transaction) {
            this.selectedTransactionID = transaction.subRetailerUserLogID;

            this.selectTransaction(transaction);
            this.selectProduct(transaction);

            const productID = transaction.productID;
            const subRetailerUserLogID = transaction.subRetailerUserLogID;
            if (transaction.categoryWithItems?.includes("SMART") && transaction.bundleID === 0) {
                await this.getProducts({ productID, subRetailerUserLogID });
                this.setShowSmartSidebar(true);
            } else {
                await this.getProductBundles(transaction.subRetailerUserLogID);
                this.setShowBundleSidebar(true);
            }
        },
        isBundle(transaction) {
            return transaction.categoryWithItems?.toLowerCase().includes('bundle');
        },
    },
    async mounted() {
        const today = new Date();
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(today.getDate() - 7);

        const dateFrom = oneWeekAgo.toISOString().split("T")[0];
        const dateTo = today.toISOString().split("T")[0];

        this.filters.dateRange = [oneWeekAgo, today];

        await this.getAllTransactions({ dateFrom, dateTo });
        this.onPageChanged(1);
    },
};
</script>

<style>
.custom-pagination .paginate-buttons {
    min-width: 35px;
    width: auto !important;
    /*override the default width to better show pagination at 3 digits*/
}

.highlighted-row {
    background-color: #E6F0E5 !important;
    transition: background-color 0.3s;
}
</style>